'use client'

import Link from 'next/link'
import React, { useCallback, useState } from 'react'

import { Button } from './ui/Button'
import { CheckboxInput } from './ui/CheckboxInput'
import { cn } from './ui/cn'

interface NewsletterSignUpFormProps {
  className?: string
}

/**
 * Ship&Play footer newsletter signup — posts to the same Drip endpoint the
 * playground uses. Rendered inside SiteFooter under the brand address block.
 */
export const NewsletterSignUpForm = ({
  className,
}: NewsletterSignUpFormProps): React.ReactElement => {
  const [agreed, setAgreed] = useState(true)
  const onSubmit = useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {
      if (!agreed) {
        e.preventDefault()
      }
    },
    [agreed],
  )

  return (
    <form
      className={className}
      action="https://www.getdrip.com/forms/106988819/submissions"
      method="post"
      data-drip-embedded-form="106988819"
      onSubmit={onSubmit}
    >
      <label
        className={cn(
          'snplay-can-focus-within snplay:flex snplay:h-14 snplay:items-center',
          'snplay:rounded-lg snplay:bg-background snplay:p-0.5',
          'snplay:text-base snplay:xs:max-w-80 snplay:sm:text-sm',
        )}
      >
        <input
          type="email"
          name="email"
          placeholder="Enter your email"
          required
          className={cn(
            'snplay:h-full snplay:w-full snplay:pl-4 snplay:pr-2',
            'snplay:text-base snplay:text-ui-primary snplay:outline-0 snplay:ring-0',
            'snplay:sm:text-sm',
          )}
        />
        <Button
          variant="brand"
          className={cn(
            'snplay:h-full snplay:rounded-md',
            'snplay:active:translate-y-0 snplay:active:scale-95',
          )}
        >
          Sign Up
        </Button>
      </label>
      <CheckboxInput
        label={
          <>
            I agree to Ship&Play{' '}
            <Link href="/terms" className="snplay-link snplay-can-focus" target="_blank">
              Terms of Use
            </Link>{' '}
            and{' '}
            <Link href="/privacy" className="snplay-link snplay-can-focus" target="_blank">
              Privacy Policy
            </Link>
            .
          </>
        }
        variant="inverted"
        name="i_agree"
        checked={agreed}
        onChange={(e) => setAgreed(e.target.checked)}
        className="snplay:mt-2"
      />
    </form>
  )
}
